<!--
@Author: Calvin Green <calvin>
@Date:   2022-01-11T13:51:01+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-02-01T10:43:40+02:00
@Copyright: Diversitude 2021
-->



<template>
    <Layout>
        <b-row>
            <b-col xl="2"  sm="3">
                <keep-alive>
                    <Menu @back="handleBack"/>
                </keep-alive>
            </b-col>
            <b-col xl="10"  sm="9">
                <ProfileDashboard/>
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
import ProfileDashboard from '@/components/client/administration/profileDashboard.vue'
import {layoutMethods} from '@/state/helpers';

export default {
    data:() => ({
        isEditing: false,
        isEditingClient: false,
        isNewDocument: false,
        hideMenu: false,

        showStats: false,
        showDistribution: false,
    }),
    components:{
        Layout,
        Menu,
        ProfileDashboard,
    },
    computed: {
        
    },
    methods: {
        ...layoutMethods,
        handleBack(){
            this.updateMenuType({
                type: 'client_administration',
                showMenu: true,
                showRoutes: false,
            });
            this.isEditing = false;
            this.isEditingClient = false;
            this.showStats = false;
            this.showDistribution = false;
        },

    },
    mounted(){
        this.$nextTick(()=>{
            this.updateMenuType({
                type: 'client_administration',
                showMenu: true,
                showRoutes: false,
            })
        })
    },
    beforeDestroy(){
        this.updateMenuType({
            type: 'Nothing',
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
